import LoginWidget from "../../organism/LoginWidget";
import LoginWidgetNZ from "../../organism/LoginWidgetNZ";
import { useState, useEffect } from "react";
import * as Action from "@mywvglobal-shared/mywv-shared/action/loginAction";
import { useDispatch, useSelector } from "react-redux";
import * as Locale from "@mywvglobal-shared/mywv-shared/locales";
import Footer from "../../organism/Footer";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { ResolutionText } from "../../atoms/TextField";
import { PageLoaderNew } from "../../atoms/Loader";
import { useTranslation } from "react-i18next";
import { isMobile } from "../../../utilities/deviceUtilities.js";
// import CommonModalPopup from "../../organism/CommonModalPopup";
import { LoginLayout } from "../../atoms/Layout";
import CommonModalPopup from "../../organism/CommonModalPopup";
// import CountrySelection from "../../molecule/CountrySelection";
import * as CountryListAction from "@mywvglobal-shared/mywv-shared/action/countryListAction";
import { SelectionFlag, SelectionItem, SelectionName, SelectionWrapper } from "../../atoms/PreLogin";
import { AppVersion } from "../../organism/AppVersion";
import useAlert from "../../../hooks/useAlert.js";
import { getCookie } from "../../../utilities/cookieUtilities.js";
import { constants } from "../../../constants/index.js";
import { checkSSOStatus } from "../../../utilities/cookieUtilities.js";

const Login = () => {
  const [soDetails, setSoDetails] = useState(undefined);
  const { persistItemsReducer } = useSelector((state) => state);
  const { countryListReducer } = useSelector((state) => state);
  const [supportOfficeList, setSupportOfficeList] = useState(countryListReducer?.countryList?.serviceResponse?.supportOfficeList);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const [showCountrySelection, setShowCountrySelection] = useState(false);
  const params = useParams(undefined);
  const [selectedSOName, setSelectedSOName] = useState(null);
  // const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const { setAlert } = useAlert();

  useEffect(() => {
    const ssoCookie = getCookie(constants?.so_NZLO?.nzSSOCookieName);
    if (ssoCookie && !checkSSOStatus()) {
      setSelectedSOName("nzlo");
    } else {
      setShowCountrySelection(false)
      if (location?.origin?.includes(".nz") || params?.soname == "nzlo") {
        setSelectedSOName("nzlo");
      }else  {
        setSelectedSOName(params?.soname);
      } 
    }
  }, []);

  useEffect(() => {
    if (document?.referrer && document?.referrer?.includes("onelogin") && searchParams.get("user_identifier") && searchParams.get("user_identifier") !== "") {
      setAlert(t("info"), t("Infotext"), "", "", "error", false, false, false)
    }
  }, [t, searchParams.get("user_identifier")])

  useEffect(async () => {
    if (selectedSOName !== null) {
      fetchCountryList()
    }
  }, [selectedSOName]);

  if (!soDetails && !searchParams.get("code")) {
    setSoDetails(persistItemsReducer?.selectedSOData);
  }

  const fetchCountryList = () => {
    const param = {
      baseURL: process.env.REACT_APP_BASE_URL,
      appVersion: "28",
      deviceType: "web",
      officeCode: selectedSOName,
    };
    dispatch(CountryListAction.countryListRequest(param));
  };

  useEffect(() => {
    showCountrySelection && fetchCountryList();
  }, [showCountrySelection]);

  useEffect(() => {
    setSupportOfficeList(countryListReducer?.countryList?.serviceResponse?.supportOfficeList);
  }, [countryListReducer]);


  useEffect(() => {
    Locale.setLanguage(soDetails?.soLanguageCultureCode);
  }, [soDetails]);

  useEffect(() => {
    if (soDetails?.soCode && !searchParams.get("code")) {
      setShowCountrySelection(false)
      selectedSOName && getSOConfigurations();
    }
  }, [soDetails]);

  const getSOConfigurations = () => {
    dispatch(Action.clearLoginReducer());
    const param = {
      baseURL: process.env.REACT_APP_BASE_URL,
      appVersion: "28",
      soCode: soDetails?.soCode,
      deviceType: "Web",
      languageCode: soDetails?.soLanguageCode,
    }
    // dispatch action in redux call
    dispatch(Action.getSOConfigurationRequest(param));
  }

  return (
    <>
      {
        showCountrySelection && !countryListReducer.loading ?
          <LoginLayout>
            <CommonModalPopup
              type="warning"
              showIcon={false}
              show={true}
              title="Select country"
              body={<CountryList supportOfficeList={supportOfficeList} />}
              bodycomp={true}
              selectCountry
            />
          </LoginLayout>
          :

          (searchParams.get("code") && searchParams.get("code") !== "")
            ?
            <div style={{ "height": "100vh" }}>
              <PageLoaderNew>
                <div className="spinner--wv-star">
                  <div className="double-bounce1"></div>
                  <div className="double-bounce2"></div>
                </div>
                {persistItemsReducer?.selectedSOData?.soCode == "NZLO" ?
                  <span className="loader_text">{localStorage.getItem("LoadingYourAccountNZ")}</span> : ""}
              </PageLoaderNew>
            </div>
            :
            <LoginLayout isNZ={selectedSOName?.toLowerCase() == "nzlo" ? true : false}
              isNZMobile={selectedSOName?.toLowerCase() == "nzlo" && isMobile ? true : false}>
              {selectedSOName?.toLowerCase() == "nzlo" ? <LoginWidgetNZ setSoDetails={setSoDetails} soDetails={soDetails} />
                : <LoginWidget setSoDetails={setSoDetails} soDetails={soDetails} />}
              {isMobile() && params?.soname !== "nzlo" ? "" :
                <ResolutionText>{t("ResolutionText")}</ResolutionText>}
              <AppVersion page="login" />
            </LoginLayout>
      }
      <Footer />
    </>
  )
}
export default Login;


const CountryList = (props) => {
  return (
    <SelectionWrapper>
      {(props?.supportOfficeList?.length > 1) && props?.supportOfficeList.map((value) => {
        return value && value?.soCode != "NZLO" ?
          <SelectionItem>
            <Link to={`/${value?.soCode.toLowerCase()}`}>
              {value.soFlag && <SelectionFlag src={value.soFlag} alt="country-flag" />}
              <SelectionName className="selected-lang">{value?.soName}</SelectionName>
              {/* <img src={downArrow} alt="down-arrow" style={{right: "15px", position: "absolute"}}/> */}
            </Link>
          </SelectionItem> :
          <SelectionName>
            {/* {USA && <img src={USA} style={{marginRight: "5px", width: "27px", height: "17px"}} alt="country-flag"/>}
                  {/* <span>{"USA"}</span> */}
            {/* {downArrow && <img src={downArrow} alt="down-arrow" style={{right: "15px", position: "absolute"}}/>}               */}
          </SelectionName>
      })}
    </SelectionWrapper>
  )
}